import React from 'react'
import styles from './styles.module.css'

export function Illustration({ editor }: { editor: boolean }) {
  return (
    <svg className={styles.illustration} viewBox="0 0 340 220" fill="none" aria-hidden="true" focusable="false">
      {editor ? (
        <>
          <g transform="rotate(4 186 100)" opacity="0.7">
            <rect x="64" y="24" width="266" height="158" rx="13" fill="white" stroke="#E5E8EC" />
            <circle cx="90" cy="49" r="13" fill="#BEEEDD" />
            <rect x="113" y="43" width="70" height="7" rx="3.5" fill="#DEE2E6" />
          </g>
          <g className={styles.card}>
            <rect x="24" y="48" width="276" height="170" rx="13" fill="white" stroke="#DFE3E7" />
            <path d="M24 101H300" stroke="#ECEFF2" />
            <circle cx="53" cy="75" r="14" fill="#D6EAF2" />
            <g stroke="#4599B8" strokeWidth="1.2" strokeLinejoin="round">
              <path d="M48 72h2l1-2h4l1 2h2v7H48z" />
              <circle cx="53" cy="75" r="1.8" />
            </g>
            <rect x="77" y="66" width="60" height="8" rx="4" fill="#D6DADF" />
            <rect x="77" y="79" width="110" height="6" rx="3" fill="#ECEEF1" />
            <rect x="264" y="70" width="22" height="13" rx="6.5" fill="#22272A" />
            <circle cx="279" cy="76.5" r="4.5" fill="white" />
            <rect x="39" y="113" width="70" height="6" rx="3" fill="#E0E3E7" />
            <rect x="39" y="128" width="246" height="22" rx="5" stroke="#E8EBEF" />
            <rect x="39" y="159" width="246" height="46" rx="6" fill="#F9F9FA" stroke="#EFF0F3" />
            <rect x="48" y="168" width="30" height="29" rx="5" fill="#D5DAE0" />
            <rect x="84" y="168" width="30" height="29" rx="5" fill="#CDD3DA" />
            <rect x="120" y="168" width="29" height="29" rx="4" fill="white" stroke="#C5CDD5" strokeDasharray="3 2" />
          </g>
        </>
      ) : (
        <>
          {[
            { x: 20, y: 34, angle: -3, color: '#E6F2F6', opacity: 0.6 },
            { x: 62, y: 82, angle: 2, color: '#CEF1E4', opacity: 0.8 },
            { x: 42, y: 132, angle: -1, color: '#FBE3F0', opacity: 1 },
          ].map(({ x, y, angle, color, opacity }) => (
            <g
              key={y}
              className={styles.card}
              transform={`translate(${x} ${y}) rotate(${angle} 130 30)`}
              opacity={opacity}
            >
              <rect width="260" height="61" rx="11" fill="white" stroke="#E6E9ED" />
              <circle cx="31" cy="30" r="18" fill={color} />
              <rect x="62" y="20" width="64" height="7" rx="3.5" fill="#EAEDF0" />
              <rect x="62" y="34" width="148" height="8" rx="4" fill="#DFE3E7" />
            </g>
          ))}
        </>
      )}
    </svg>
  )
}
